// extracted by mini-css-extract-plugin
module.exports = {"content":"_924b119625--content--L2Sgr","name":"_924b119625--name--D6vIe"};